import React from 'react';

import type { AgentExecutionStep } from './AgentMessage';

/** Pick the single line to show — active step, else latest completed, else fallback. */
export function resolveActiveStepText(steps: AgentExecutionStep[]): string {
  const active = steps.find((s) => s.status === 'active');
  if (active?.label) return active.label;

  for (let i = steps.length - 1; i >= 0; i--) {
    if (steps[i]?.status === 'completed' && steps[i]?.label) {
      return steps[i]!.label;
    }
  }

  return steps[0]?.label ?? 'Processing…';
}

interface AgentStatusInlineProps {
  steps: AgentExecutionStep[];
}

/**
 * Single-line processing indicator — one label at a time with a short fade swap.
 */
export const AgentStatusInline: React.FC<AgentStatusInlineProps> = ({ steps }) => {
  const text = resolveActiveStepText(steps);

  return (
    <div
      className="agent-status-container mb-2"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="agent-status-dot" aria-hidden />
      <span className="agent-status-viewport">
        <span key={text} className="agent-status-text is-fading-in">
          {text}
        </span>
      </span>
    </div>
  );
};
